export const ScrollToPositionFixed = (pos, scroll) => {
  if (pos) {
    if (document.querySelector('.background') && document.querySelector('.background').classList.contains('decision')) {
      if (window.innerWidth > 1366) {
        document.querySelector('html').classList.remove('scroll0');
        document.querySelector('body').classList.remove('scroll0');
      } else {
        const top = parseInt(document.querySelector('html').style.top) * -1;
        document.querySelector('html').classList.remove('fixed');
        document.querySelector('html').style.top = '0px';
        window.scrollTo(0, top)
      }
    } else {
      const top = parseInt(document.querySelector('html').style.top) * -1;
      document.querySelector('html').classList.remove('fixed');
      document.querySelector('html').style.top = '0px';
      window.scrollTo(0, top)
    }
  } else {
    if (document.querySelector('.background') && document.querySelector('.background').classList.contains('decision')) {
      if (window.innerWidth > 1366) {
        document.querySelector('html').classList.add('scroll0');
        document.querySelector('body').classList.add('scroll0');
      } else {
        document.querySelector('html').classList.add('fixed');
        document.querySelector('html').style.top = '-'+ scroll +'px';
      }
    } else {
      document.querySelector('html').classList.add('fixed');
      document.querySelector('html').style.top = '-'+ scroll +'px';
    }
  }
};